import React from "react";
import {useTranslation} from "react-i18next";


const PaymentHeroSection = ({onScrollToForm}) =>{
    const {t} = useTranslation('paymentpage');
    return(
        <section className="payment-hero-section">
                <div className="section-container payment-hero-section-content">
                <div className="left-payment-hero-section">
                    <div className="left-payment-hero-section-content">
                        <span>{t('left-payment-hero-section.line1')}</span> {t('left-payment-hero-section.line2')} <br/>{t('left-payment-hero-section.line3')}<br/>
                        <p>{t('left-payment-hero-section.line4')}</p>
                        <button className="btn-big btn-primary btn-mobile" onClick={onScrollToForm}>{t('left-payment-hero-section-button')}</button>
                    </div>
                </div>
                <div className="right-payment-hero-section">
                    <div className="right-payment-hero-section-img">
                        <img src="/images/payment_hero_section_img.webp" alt="payment-page-img"/>
                    </div>
                    </div>
                </div>
        </section>
    )
}


export default PaymentHeroSection;